import { render, staticRenderFns } from "./BenefitDetail.vue?vue&type=template&id=7b96f333"
import script from "./BenefitDetail.vue?vue&type=script&lang=js"
export * from "./BenefitDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports